module.exports = __webpack_public_path__ + "img/1538257225.d3a578b5.jpg";